import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react'
import { api } from './baseRtkqApi'

export interface GuardianLoginRequest {
  phone: string
  fullName?: string
  birthYear?: number
  turnstileToken?: string
}

export type GuardianLoginError = FetchBaseQueryError & {
  retryAfterSeconds?: number
}

export interface GuardianLoginResponse {
  token: string
  expiresAt: string
}

export interface GuardianMeResponse {
  phone: string
}

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<GuardianLoginResponse, GuardianLoginRequest>({
      query: (body) => ({
        url: '/api/auth/guardian/login',
        method: 'POST',
        body,
      }),
      transformErrorResponse: (
        response,
        meta: FetchBaseQueryMeta | undefined
      ): GuardianLoginError => {
        const header = meta?.response?.headers.get('Retry-After')
        const retryAfterSeconds = header ? Number(header) : undefined
        return {
          ...response,
          retryAfterSeconds:
            retryAfterSeconds && !Number.isNaN(retryAfterSeconds)
              ? retryAfterSeconds
              : undefined,
        }
      },
    }),
    getMe: build.query<GuardianMeResponse, void>({
      query: () => '/api/auth/guardian/me',
    }),
  }),
})

export const { useLoginMutation, useGetMeQuery } = authApi
